// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"faqCard_listContainer__3g4e9","faqRowContainer":"faqCard_faqRowContainer__3s4UR","faqRow":"faqCard_faqRow__15khF","faqImageColumn":"faqCard_faqImageColumn__27mG2"};